import {authAxios} from "./axiosClient";
import {
        changeStatusCCHRURL,
        changeStatusCCURL,
        chinhSuaChamCongURL, ChotCongURL,
        NhanSuChiTietCongURL,
        QuanLyChiTietCongURL, TongHopChamCongQuanLyURL, TongHopChamCongURL
} from "../constants";

export const quanLyChiTietCongApi = (params={})=>{
        return authAxios().get(QuanLyChiTietCongURL,{params})
}
export const nhanSuChiTietCongApi = (params={})=>{
        return authAxios().get(NhanSuChiTietCongURL,{params})
}

export const changeStatusCCApi = (params={})=>{
        return authAxios().put(changeStatusCCURL,params)
}

export const changeStatusCCHRApi = (params={})=>{
        return authAxios().put(changeStatusCCHRURL,params)
}

export const chinhSuaChamCongApi = (params={})=>{
        return authAxios().put(chinhSuaChamCongURL,params)
}

export const tongHopChamCongApi = (params={})=>{
        return authAxios().get(TongHopChamCongURL,{params})
}

export const tongHopChamCongQuanLyApi = (params={})=>{
        return authAxios().get(TongHopChamCongQuanLyURL,{params})
}


export const chotCongApi = (params={})=>{
        return authAxios().put(TongHopChamCongURL,params)
}

export const danhSachChotCongApi = (params={})=>{
        return authAxios().get(ChotCongURL,{params})
}

export const dieuChinhCongCaNhanApi = (params={})=>{
        return authAxios().put(ChotCongURL,params)
}
